import React, {useEffect, useState} from "react";
import {Alert, Box, Button, Typography} from "@mui/material";
import {CreditCardOutlined} from '@mui/icons-material';
import UpdatePaymentMethod from "./UpdatePaymentMethod";
import {subscriptionServices} from "../../../service/subscriptionService";
import Spinner from "../../spinner/Spinner";
import UpdateBillingDetails from "./UpdateBillingDetails";
import {SubscriptionCard, SubscriptionSectionTitle, subscriptionInset} from "./SubscriptionDesign";
import {SettingsEmptyState} from "../SettingsDesign";

function PaymentMethod() {
    const [openUpdatePaymentMethod, setOpenUpdatePaymentMethod] = useState(false);
    const [openUpdateBillingDetails, setOpenUpdateBillingDetails] = useState(false);
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState("");
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [reloadPaymentMethod, setReloadPaymentMethod] = useState(true);

    const handleCloseUpdateBillingDetails = () => {
        setOpenUpdateBillingDetails(false);
    };

    const handleClickOpenUpdateBillingDetails = () => {
        setOpenUpdateBillingDetails(true);
    };

    const handleClickOpenUpdatePaymentMethod = () => {
        setOpenUpdatePaymentMethod(true);
    };

    const handleCloseUpdatePaymentMethod = () => {
        setOpenUpdatePaymentMethod(false);
    };

    const handleReloadPaymentMethod = () => {
        setReloadPaymentMethod(true);
    };

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            setErrorMsg('');
            await subscriptionServices.getPaymentMethod().then((result) => {
                setPaymentMethod(result);
            }).catch(error => {
                setErrorMsg(error?.response?.data?.error || 'Unable to load your payment method. Please try again.');
            }).finally(() => {
                setLoading(false);
                setReloadPaymentMethod(false);
            });
        }

        if (reloadPaymentMethod) {
            fetchData();
        }
    }, [reloadPaymentMethod]);

    return <SubscriptionCard sx={{minHeight: 200}}>
        <SubscriptionSectionTitle icon={CreditCardOutlined} title="Payment & billing" description="Manage the card and billing information for your subscription."/>
        {loading && <Spinner size={32} overComponentBox noBackShadow/>}
        {errorMsg && <Alert severity="error" variant="filled" sx={{mb: 2}}>{errorMsg}</Alert>}
        {!loading && <>
            {paymentMethod?.brand ? <Box sx={{...subscriptionInset, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1.5}}>
                <CreditCardOutlined sx={{fontSize: 28, color: 'text.secondary'}}/>
                <Box sx={{flexGrow: 1}}>
                    <Typography sx={{fontSize: 14, fontWeight: 600, textTransform: 'capitalize'}}>{paymentMethod.brand} •••• {paymentMethod.last4}</Typography>
                    <Typography sx={{fontSize: 12, color: 'text.secondary', mt: 0.5}}>Expires {paymentMethod.expMonth}/{paymentMethod.expYear}</Typography>
                </Box>
            </Box> : !errorMsg && <SettingsEmptyState icon={CreditCardOutlined} title="No payment method" description="Add a card to manage your subscription payments."/>}
            <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))'}, gap: 1.5, mt: 2.5}}>
                <Button variant="outlined" color="inherit" onClick={handleClickOpenUpdateBillingDetails}>Update billing details</Button>
                <Button variant="contained" onClick={handleClickOpenUpdatePaymentMethod}>Update payment method</Button>
            </Box>
        </>}
        {openUpdateBillingDetails && <UpdateBillingDetails open onClose={handleCloseUpdateBillingDetails}/>}
        {openUpdatePaymentMethod && <UpdatePaymentMethod open onClose={handleCloseUpdatePaymentMethod} reloadPaymentMethod={handleReloadPaymentMethod}/>}
    </SubscriptionCard>;
}

export default PaymentMethod;
